import { Label } from '@cian/ui-kit';

import * as React from 'react';

export const OwnerBadge: React.FC = () => {
  return (
    <Label background="surface-positive-default" color="accent-positive-primary">
      Собственник
    </Label>
  );
};
